document.addEventListener('DOMContentLoaded', function () {
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (event) {
        const swatches = document.querySelectorAll('.bold_option_swatch .bold_option_value');
        swatches.forEach((swatch) => {
            const imageEl = swatch.querySelector('.bold_option_value_swatch');
            const tooltip = swatch.querySelector('.bold_option_swatch_title');
            const swatchTitle = tooltip.querySelector('.bold_option_value_title');
            swatch.querySelector('.bold_option_value_element').append(swatchTitle.cloneNode(true));
            tooltip.prepend(imageEl.cloneNode(true));
        });

        document.addEventListener('mouseover', (e) => {
            const isSwatchHover = !!e.target.closest('.bold_option_swatch .bold_option_value');
            const parent = e.target.closest('.bold_option_swatch .bold_option_value');
            if (isSwatchHover) {
                const popupEl = parent.querySelector('.bold_option_swatch_title');
                const popupElRectangle = popupEl.getBoundingClientRect();
                if (popupElRectangle.right > window.innerWidth) {
                    const offsetRight = popupEl.offsetRight || 0;
                    const shift = popupElRectangle.right - window.innerWidth;
                    popupEl.style = `left:-${offsetRight + shift}px`;
                } else if (popupElRectangle.left < 0) {
                    window.requestAnimationFrame(() => {
                        const offsetLeft = popupEl.offsetLeft;
                        const shift = Math.abs(popupElRectangle.left);
                        popupEl.style = `left:${offsetLeft + shift + parseInt(window.getComputedStyle(popupEl).fontSize.replace('px', ''))}px`;
                    })
                }
            }
        })
    })
})